import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import { computed, ref } from 'vue';
import { debounce } from 'JS/utilities/debounce';
import { IWebSiteMenu } from 'Src/js/types/Header';


export default /*#__PURE__*/_defineComponent({
  __name: 'MegaMenuDepartment',
  props: {
    menuItem: null,
    currentDepth: null,
    maxDepth: null
  },
  setup(__props: any) {

const props = __props as {
	menuItem: IWebSiteMenu,
	currentDepth: number,
	maxDepth: number,
}



const activeMenuId = ref<string>("");

const setActiveMenuIdDebounced = debounce(400, (newMenuId)=> {
	activeMenuId.value = newMenuId;
});

const atFinalDepth = computed(()=> {
	return props.currentDepth >= props.maxDepth;
});
function toggleDepartment(departmentId: string) {
	activeMenuId.value = activeMenuId.value !== departmentId ? departmentId : "";
}

function handleShopAllMouseEnter() {
	/*
	* setting it twice allows us to be reactive to hovering the shop
	* all immediately, while also preventing a different debounce
	* from re-adding a different activeMenuId
	*/
	activeMenuId.value = null;
	setActiveMenuIdDebounced(null);
}


return { __sfc: true,props, activeMenuId, setActiveMenuIdDebounced, atFinalDepth, toggleDepartment, handleShopAllMouseEnter, Icon }
}

})